"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("abortcontroller-polyfill/dist/polyfill-patch-fetch");
var node_fetch_1 = __importDefault(require("node-fetch"));
// MLB's data-service returns a 403 HTML page to the default node-fetch User-Agent.
var MlbRequestHeaders = {
    "User-Agent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/120.0.0.0 Safari/537.36",
    "Accept": "application/json"
};
var Internal_DataLoaderNode = /** @class */ (function () {
    function Internal_DataLoaderNode() {
    }
    Internal_DataLoaderNode.parseJson = function (response) {
        return __awaiter(this, void 0, void 0, function () {
            var contentType, body;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        contentType = response.headers.get("content-type") || "";
                        return [4 /*yield*/, response.text()];
                    case 1:
                        body = _a.sent();
                        if (!response.ok || contentType.indexOf("json") === -1) {
                            throw new Error("Upstream ".concat(response.status, " (").concat(contentType || "unknown type", "): ").concat(body.slice(0, 120)));
                        }
                        return [2 /*return*/, JSON.parse(body)];
                }
            });
        });
    };
    Internal_DataLoaderNode.prototype.loadNode = function (url_1) {
        return __awaiter(this, arguments, void 0, function (url, uniqueRequestType) {
            if (uniqueRequestType === void 0) { uniqueRequestType = ""; }
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var catcher = function (error) {
                            console.log("error", error);
                            if (error.statusText === "abort") {
                                return;
                            }
                            reject(error);
                        };
                        (0, node_fetch_1.default)(url, { headers: MlbRequestHeaders })
                            .then(function (response) { return Internal_DataLoaderNode.parseJson(response); })
                            .then(function (myJson) { return resolve(myJson); })
                            .catch(catcher);
                    })];
            });
        });
    };
    Internal_DataLoaderNode.prototype.load = function (url_1) {
        return __awaiter(this, arguments, void 0, function (url, uniqueRequestType) {
            var result;
            if (uniqueRequestType === void 0) { uniqueRequestType = ""; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadNode(url, uniqueRequestType)];
                    case 1:
                        result = _a.sent();
                        if (typeof result === "string") {
                            if (result.length === 0) {
                                return [2 /*return*/, null];
                            }
                            return [2 /*return*/, JSON.parse(result)];
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    Internal_DataLoaderNode.Instance = new Internal_DataLoaderNode();
    return Internal_DataLoaderNode;
}());
exports.default = Internal_DataLoaderNode.Instance;
